/**
 * Toast do aviso da agenda que acabou de chegar (agenda v2, Fase 3).
 *
 * O sino já consulta o resumo dos avisos a cada minuto
 * (useNotificacoesAgregadas); aqui só se compara o mais recente não lido com
 * o último visto. O primeiro resumo apenas registra o que já existia: abrir o
 * sistema não toca aviso velho. "Abrir" leva à tarefa.
 */
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { useToast } from "../../context/ToastContext";
import useNotificacoesAgregadas from "../../hooks/useNotificacoesAgregadas";

export default function AvisosDaAgenda() {
  const { avisos, atualizadoEm } = useNotificacoesAgregadas();
  const toast = useToast();
  const navigate = useNavigate();
  const ultimoVistoRef = useRef(undefined);
  const ultimo = avisos?.ultimo || null;

  useEffect(() => {
    if (!atualizadoEm) return;
    const anterior = ultimoVistoRef.current;
    ultimoVistoRef.current = ultimo?.id || null;
    if (anterior === undefined || !ultimo || ultimo.id === anterior) return;
    toast.info(ultimo.texto ? `${ultimo.titulo} · ${ultimo.texto}` : ultimo.titulo, {
      actionLabel: ultimo.link ? "Abrir" : undefined,
      onAction: ultimo.link ? () => navigate(ultimo.link) : undefined,
    });
  }, [ultimo, atualizadoEm, navigate, toast]);

  return null;
}
